import React, { Component } from "react";
import Calendar from "react-calendar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { thisExpression } from "@babel/types";

export default class CreateSession extends Component {
  state = {
    startDate: new Date(),
    sessionName: "",
    sessionDescription: "",
    subject: "",
    topic: "",
    sessionType: "",
    duration: "",
    seats: "",
    seheduleType: "",
    fees: ""
  };
  handleDayTime = date => {
    this.setState({
      startDate: date
    });
  };
  handleSessionType = e => {
      this.setState({ sessionType: e.target.value });
  };
  onInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  createZoomSession = () => {
    var data = JSON.stringify({
      "topic": "test",
      "type": "1",
      "start_time": "",
      "duration": "",
      "timezone": "",
      "password": "",
      "agenda": "test"
    });
    
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === this.DONE) {
        console.log(this.responseText);
      }
    });
    
    xhr.open("POST", "https://api.zoom.us/v2/users/-oyRZQXbRw2F-kvNUVXQmw/meetings");
    xhr.setRequestHeader("content-type", "application/json");
    xhr.setRequestHeader("authorization", "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOm51bGwsImlzcyI6ImlUV2tYZzFEVGNXaFUwbTlwZThXRHciLCJleHAiOjI1MTMxNDA3NDAsImlhdCI6MTU2NjM2NDE4Mn0.1uJfjuzV5o8Jqg5gUJg_tV_2pUNNW_34j1HF_mL9wdI");
    xhr.setRequestHeader( 'Access-Control-Allow-Origin', '*');

    xhr.send(data);


    // fetch("https://api.zoom.us/v2/users/-oyRZQXbRw2F-kvNUVXQmw/meetings", {
    //   method: 'post',
    //   headers: {
    //     "Content-type": "application/json",
    //     'Accept' : 'application/json',
    //     "authorization" : "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOm51bGwsImlzcyI6ImlUV2tYZzFEVGNXaFUwbTlwZThXRHciLCJleHAiOjI1MTMxNDA3NDAsImlhdCI6MTU2NjM2NDE4Mn0.1uJfjuzV5o8Jqg5gUJg_tV_2pUNNW_34j1HF_mL9wdI",
    //   },
    //   body: data, 
    //   credentials: 'same-origin',
    //   mode:"no-cors"
    // })
    // .then(function (data) {
    //   console.log( data);
    // })
    // .catch(function (error) {
    //   console.log('Request failed', error);
    // });
  }
  render() {
    return (
      <div className="pt-3">
      <div className="container selection-container create-session">
        <div className="step card card-body">
          <div className="step-item stepper container">
            <div className="my-3 text-center">
              <h4>Create Session</h4>
              <p className="blockquote-footer">
                Choose your Time and day for session.
              </p>

              <div className="row">
                {/* <div class="col-md-4">
                  <div
                    className="p-0 banner-wrap"
                    id="banner-input-wrap"
                    onClick={this.changePicture}
                  >
                    <img
                      src="https://unlimitedpassion.co.uk/wp-content/uploads/2016/06/placeholder4.png"
                      alt=""
                      style={{ width: "" }}
                      className="image-cover"
                    />
                  </div>
                  <input
                    type="file"
                    class="edit-mode"
                    id="input-image"
                    name="image"
                    accept="image/*"
                    capture
                    style={{ display: "none" }}
                    // onChange={this.setImage}
                  />
                </div> */}
                <div className="col-md-12">
                  <form>
                    <div class="form-group m-0 row p-1">
                      <input
                        type="text"
                        class="form-control"
                        name="sessionName"
                        placeholder="Session Name"
                        required="required"
                        value={this.state.sessionName}
                        onChange={this.onInputChange}
                        //   onChange={this.onInputChange}
                        //   value={this.state.firstName}
                      />
                    </div>
                    <div class="form-group m-0 row p-1">
                      <textarea
                        type="text"
                        class="form-control"
                        name="sessionDescription"
                        placeholder="Session Description"
                        required="required"
                        value={this.state.sessionDescription}
                        onChange={this.onInputChange}
                        // onChange={this.onInputChange}
                        // value={this.state.aboutMe}
                      />
                    </div>

                    <div class="form-group m-0 row mt-3 text-left">
                      <div className="col-md-6 p-1">
                        Select Subject
                        <div className="card border card-selector mini d-flex flex-row day-picker duration">
                          <i class="fas fa-book" />
                          <select
                            class=""
                            id="exampleFormControlSelect1"
                            onChange={this.handleChange}
                            name="subject"
                            value={this.state.subject}
                            onChange={this.onInputChange}
                          >
                            <option>Math</option>
                            <option>Physics</option>
                            <option>Bio</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6 p-1">
                        Select Topic
                        <div className="card border card-selector mini d-flex flex-row day-picker duration">
                          <i class="fas fa-book-open" />
                          <select
                            class=""
                            id="exampleFormControlSelect1"
                            onChange={this.handleChange}
                            name="topic"
                            value={this.state.topic}
                            onChange={this.onInputChange}
                          >
                            <option>Algebra</option>
                            <option>Logic</option>
                            <option>Geometry</option>
                            <option>Calculas</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row m-0">
                      <div className="col-md-4 p-1 text-left">
                        Select Session Type
                        <div className="card border card-selector mini  d-flex flex-row day-picker duration">
                          <i class="fas fa-desktop" />
                          <select
                            class=""
                            id="exampleFormControlSelect1"
                            onChange={this.handleSessionType}
                            name="sessionType"
                          >
                            <option value="live">Go live</option>
                            <option value="sehedule">Seheduled</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    {this.state.sessionType === "sehedule" ? (
                      <div>
                        <hr />

                        <div class="form-group m-0 row mt-3 text-left">
                          <div className="col-md-4 p-1">
                            Select Day
                            <div className="card border card-selector mini  d-flex flex-row day-picker">
                              <i class="far fa-calendar-alt" />
                              <DatePicker
                                selected={this.state.startDate}
                                onChange={this.handleDayTime}
                                dateFormat="MMMM d, yyyy"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 p-1">
                            Select time
                            <div className="card border card-selector mini  d-flex flex-row day-picker">
                              <i class="far fa-clock" />
                              <DatePicker
                                selected={this.state.startDate}
                                onChange={this.handleDayTime}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                dateFormat="h:mm aa"
                                timeCaption="Time"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 p-1">
                            Select duration
                            <div className="card border card-selector mini  d-flex flex-row day-picker duration">
                              <i class="fas fa-hourglass-end" />
                              <select
                                class=""
                                id="exampleFormControlSelect1"
                                onChange={this.handleChange}
                                name="duration"
                                value={this.state.duration}
                                onChange={this.onInputChange}
                              >
                                <option>30 min</option>;<option>45 min</option>;
                                <option>60 min</option>;
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="form-group m-0 row mt-3 text-left">
                          <div className="col-md-4 p-1">
                            Available seats
                            <div className="card border card-selector mini  d-flex flex-row day-picker duration">
                              <i class="fas fa-chair" />
                              <input
                                placeholder="5"
                                name="seats"
                                type="number"
                                value={this.state.seats}
                                onChange={this.onInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-4 p-1">
                            Type
                            <div className="card border card-selector mini  d-flex flex-row day-picker duration">
                              <i class="fas fa-bars" />
                              <select
                                class=""
                                id="exampleFormControlSelect1"
                                onChange={this.handleChange}
                                name="seheduleType"
                                value={this.state.seheduleType}
                                onChange={this.onInputChange}
                              >
                                <option>Paid</option>
                                <option>Free</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4 p-1">
                            Fees
                            <div className="card border card-selector mini  d-flex flex-row day-picker">
                              <i class="fas fa-rupee-sign" />
                              <input
                                placeholder="20"
                                name="fees"
                                type="number"
                                value={this.state.fees}
                                onChange={this.onInputChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="row m-1 mt-4">
                      <a href="#" class="btn btn-primary mr-2" onClick={this.createZoomSession}>
                        Create Session
                      </a>
                      {/* <a href="#" class="btn btn-primary">
                        Go live now
                      </a> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    );
  }
}
